<template>
  <ModalDialog
    ref="dialog"
    title="Update Price List Template"
    :submitting="submitting"
    submitTitle="Submit"
    icon="fa-money-check-edit-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <Spinner v-if="loading" />
      <div v-if="!loading">
        <FormRow label="Name">
          <FormInputText field="name" v-model="priceListTemplate.name" placeholder="Name" />
        </FormRow>
        <FormRow label="Description">
          <FormInputTextArea field="description" v-model="priceListTemplate.description" placeholder="Description" />
        </FormRow>
        <FormRow label="Active">
          <FormCheckbox field="isActive" v-model="priceListTemplate.isActive" />
        </FormRow>
      </div>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'PriceListTemplateEditDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    priceListTemplateId: Number
  },
  data() {
    return {
      loading: false,
      dialogForm: {},
      priceListTemplate: {},
      submitting: false
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    
  },
  methods: {
    show() {
      // Reset form
      this.dialogForm = { }
      this.submitting = false

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = {
        name: this.priceListTemplate.name,
        description: this.priceListTemplate.description,
        isActive: this.priceListTemplate.isActive
      }

      this.$apiService.pricingService.updatePriceListTemplate(this.priceListTemplateId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    requestData() {
      this.loading = true

      this.$apiService.pricingService.getPriceListTemplate(this.priceListTemplateId)
        .then((response) => {
          this.priceListTemplate = response.data
        })
        .catch(error => {
          this.displayNetworkError(error)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>